import { render } from "./StyleCardHorizontal.vue?vue&type=template&id=6d8ecb26"
import script from "./StyleCardHorizontal.vue?vue&type=script&lang=js"
export * from "./StyleCardHorizontal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/StyleCard/StyleCardHorizontal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d8ecb26"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d8ecb26', __exports__)) {
    api.reload('6d8ecb26', __exports__)
  }
  
  module.hot.accept("./StyleCardHorizontal.vue?vue&type=template&id=6d8ecb26", () => {
    api.rerender('6d8ecb26', render)
  })

}


export default __exports__